var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("距离结束 "+_vm._s(_vm.countdown))])}
var staticRenderFns = []

export { render, staticRenderFns }